<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <!-- Rows Management -->
        <div class="mb-4">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Marquee Rows</label>
            <v-btn small color="primary" @click="handleAddRow">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Row</span>
            </v-btn>
          </div>

          <v-expansion-panels accordion class="row-panels">
            <v-expansion-panel v-for="(row, rowIndex) in fields.rows" :key="`shopzovya-row-${rowIndex}`">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center pr-4">
                  <span
                    >Row {{ rowIndex + 1 }} ({{ row.items ? row.items.length : 0 }} items, Speed:
                    {{ row.speedAnimation }}s, Gap: {{ row.gapItem }}px)</span
                  >
                  <v-btn icon @click.stop="handleRemoveRow(rowIndex)">
                    <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <!-- Row Settings -->
                <v-row class="mb-4">
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model.number="row.speedAnimation"
                      type="number"
                      label="Speed"
                      min="1"
                      suffix="s"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model.number="row.gapItem"
                      type="number"
                      label="Gap item"
                      min="0"
                      suffix="px"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <ColorPicker
                      v-model="row.bgBadge"
                      name="row-bg-badge"
                      label="Badge Background"
                      default-color="#f7c4ce"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <ColorPicker
                      v-model="row.colorBadge"
                      name="row-color-badge"
                      label="Badge Text Color"
                      default-color="#ffffff"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <ColorPicker
                      v-model="row.bgItem"
                      name="row-bg-item"
                      label="Item Background"
                      default-color="#ffffff"
                    />
                  </v-col>
                </v-row>

                <!-- Row Items -->
                <div class="mb-2">
                  <div class="d-flex justify-space-between align-center">
                    <span class="font-weight-bold">Items in Row {{ rowIndex + 1 }}</span>
                    <v-btn small text color="primary" @click="handleAddItem(rowIndex)">
                      <v-icon size="16">mdi-plus</v-icon>
                      <span>Add Item</span>
                    </v-btn>
                  </div>

                  <div v-if="!row.items || !row.items.length" class="text-center py-4 grey--text">
                    No items in this row. Add some items to display.
                  </div>

                  <v-expansion-panels v-else accordion class="item-panels mt-2">
                    <v-expansion-panel
                      v-for="(item, itemIndex) in row.items"
                      :key="`shopzovya-item-${rowIndex}-${itemIndex}`"
                    >
                      <v-expansion-panel-header class="py-2">
                        <div class="d-flex justify-space-between align-center">
                          <div class="d-flex align-center" style="gap: 10px;">
                            <v-avatar size="32" class="grey lighten-3">
                              <img v-if="item.avatar" :src="item.avatar" alt="Avatar" />
                              <v-icon v-else size="18">mdi-account</v-icon>
                            </v-avatar>
                            <span>Item {{ itemIndex + 1 }} - Rating: {{ item.ratingPoint }}</span>
                          </div>
                          <v-btn icon @click.stop="handleRemoveItem(rowIndex, itemIndex)">
                            <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div class="mt-2">
                          <label class="d-block mb-1 font-weight-medium">Avatar Image</label>
                          <UploadImage
                            @callback="obj => handleUploadItemImage(obj, rowIndex, itemIndex)"
                            :image="{ imageSrc: item.avatar || '' }"
                            :height="`150`"
                            :typeUpload="'image'"
                            @callbackDelete="() => handleRemoveItemImage(rowIndex, itemIndex)"
                          />
                        </div>

                        <div class="mt-4">
                          <label class="d-block mb-1 font-weight-medium">Rating Point (1 to 5)</label>
                          <div class="d-flex align-center" style="gap: 10px;">
                            <v-rating
                              v-model="item.ratingPoint"
                              color="amber"
                              background-color="grey"
                              dense
                              half-increments
                              hover
                              size="28"
                              min="1"
                              max="5"
                            ></v-rating>
                            <span class="font-weight-bold">({{ item.ratingPoint }})</span>
                          </div>
                        </div>

                        <div class="mt-4">
                          <v-textarea v-model="item.textRating" label="Rating Text" rows="1" hide-details />
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '../common/html/update';
import ColorPicker from './common/color-picker.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

const defaultAvatar = '';

export default {
  name: 'marquee-shopzovya-section-editor',
  components: {
    UploadImage,
    ColorPicker,
    SectionSettingsContainerFuild,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: {
        title: 'Marquee Shopzovya Section',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#ffffff',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        rows: [],
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;

      const defaultRows = [
        {
          gapItem: 28,
          speedAnimation: 20,
          bgBadge: '#f7c4ce',
          bgItem: '#ffffff',
          colorBadge: '#ffffff',
          items: [
            { avatar: defaultAvatar, ratingPoint: 5, textRating: 'Honestly wish I bought these sooner' },
            { avatar: defaultAvatar, ratingPoint: 5, textRating: 'Honestly wish I bought these sooner' },
            { avatar: defaultAvatar, ratingPoint: 5, textRating: 'Honestly wish I bought these sooner' },
            { avatar: defaultAvatar, ratingPoint: 5, textRating: 'Honestly wish I bought these sooner' },
          ],
        },
        {
          gapItem: 28,
          speedAnimation: 20,
          bgBadge: '#f7c4ce',
          bgItem: '#ffffff',
          colorBadge: '#ffffff',
          items: [
            { avatar: defaultAvatar, ratingPoint: 5, textRating: 'Honestly wish I bought these sooner' },
            { avatar: defaultAvatar, ratingPoint: 5, textRating: 'Honestly wish I bought these sooner' },
            { avatar: defaultAvatar, ratingPoint: 5, textRating: 'Honestly wish I bought these sooner' },
            { avatar: defaultAvatar, ratingPoint: 5, textRating: 'Honestly wish I bought these sooner' },
          ],
        },
      ];

      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        rows:
          Array.isArray(extract.rows) && extract.rows.length > 0
            ? extract.rows.map(row => ({
                gapItem: row.gapItem !== undefined ? row.gapItem : 28,
                speedAnimation: row.speedAnimation !== undefined ? row.speedAnimation : 20,
                bgBadge: row.bgBadge || '#f7c4ce',
                bgItem: row.bgItem || '#ffffff',
                colorBadge: row.colorBadge || '#ffffff',
                items: Array.isArray(row.items)
                  ? row.items.map(item => ({
                      avatar: item.avatar || '',
                      ratingPoint: Number(item.ratingPoint) || 5,
                      textRating: item.textRating || '',
                    }))
                  : [],
              }))
            : defaultRows,
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionMarqueeShopzovya(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddRow() {
      this.fields.rows.push({
        gapItem: 28,
        speedAnimation: 20,
        bgBadge: '#f7c4ce',
        bgItem: '#ffffff',
        colorBadge: '#ffffff',
        items: [{ avatar: defaultAvatar, ratingPoint: 5, textRating: 'Honestly wish I bought these sooner' }],
      });
    },
    handleRemoveRow(index) {
      this.fields.rows.splice(index, 1);
    },
    handleAddItem(rowIndex) {
      if (!this.fields.rows[rowIndex]) return;
      this.fields.rows[rowIndex].items.push({
        avatar: defaultAvatar,
        ratingPoint: 5,
        textRating: 'Honestly wish I bought these sooner',
      });
    },
    handleRemoveItem(rowIndex, itemIndex) {
      if (!this.fields.rows[rowIndex]) return;
      this.fields.rows[rowIndex].items.splice(itemIndex, 1);
    },
    handleUploadItemImage(obj, rowIndex, itemIndex) {
      if (!this.fields.rows[rowIndex] || !this.fields.rows[rowIndex].items[itemIndex]) return;
      this.$set(this.fields.rows[rowIndex].items[itemIndex], 'avatar', obj.imageSrc || '');
    },
    handleRemoveItemImage(rowIndex, itemIndex) {
      if (!this.fields.rows[rowIndex] || !this.fields.rows[rowIndex].items[itemIndex]) return;
      this.$set(this.fields.rows[rowIndex].items[itemIndex], 'avatar', '');
    },
  },
};
</script>

<style scoped lang="scss">
.row-panels {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}
.item-panels {
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  overflow: hidden;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
